export var cleanPopovers = function () {
    var ps = Array.from(document.querySelectorAll('.Popover'));
    ps.forEach(function (e) { return e.remove(); });
};
//# sourceMappingURL=index.js.map